module.exports = __webpack_public_path__ + "img/computer.c352a7f4.png";